import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE } from "../lib/config";

const StotramsPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/stotrams`)
      .then((res) => {
        setItems(res.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <main data-testid="stotrams-page" className="bg-ivory">
      <section className="pt-40 md:pt-48 pb-20 md:pb-24 max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
            The Library
          </p>
          <h1 className="mt-6 font-heading font-normal text-charcoal text-5xl sm:text-6xl md:text-7xl tracking-tight">
            Stotrams
          </h1>
          <div className="mt-8 mx-auto w-12 h-px bg-muted_gold" />
          <p className="mt-10 text-charcoal-soft text-lg leading-relaxed">
            A curated collection of Sanskrit stotrams with complete text, transliterations and meanings in multiple languages, devotional context, traditionally understood benefits and pronunciation review—brought to life through cinematic visual storytelling.
          </p>
        </div>
      </section>

      <section className="pb-40 max-w-7xl mx-auto px-6 md:px-12">
        <div
          data-testid="stotrams-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12"
        >
          {loading &&
            Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="border border-charcoal/10 aspect-[3/4] animate-pulse bg-ivory-deeper"
              />
            ))}
          {!loading &&
            items.map((s) => (
              <Link
                key={s.id}
                to={`/stotrams/${s.slug}`}
                data-testid={`stotram-card-${s.slug}`}
                className="museum-plaque border border-charcoal/10 bg-ivory flex flex-col"
              >
                <div className="aspect-square overflow-hidden bg-ivory-deeper">
                  <img
                    src={s.image_url}
                    alt={`${s.title} — devotional artwork`}
                    className="plaque-image w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="p-8 flex-1 flex flex-col">
                  <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
                    {s.deity}
                  </p>
                  <h3 className="mt-3 font-heading font-normal text-2xl md:text-3xl text-charcoal">
                    {s.title}
                  </h3>
                  <p className="mt-1 indic-text italic text-charcoal-soft">
                    {s.sanskrit_title}
                  </p>
                  <p className="mt-4 text-[15px] text-charcoal-soft leading-relaxed line-clamp-3">
                    {s.description}
                  </p>
                  <div className="mt-6 pt-5 border-t border-charcoal/15 flex items-center justify-end">
                    <span className="text-xs tracking-[0.24em] uppercase font-medium text-charcoal">
                      Open →
                    </span>
                  </div>
                </div>
              </Link>
            ))}
        </div>
      </section>
    </main>
  );
};

export default StotramsPage;
